export * from './bet-type-content';